import { Box, Grid, TextField, Typography } from "@mui/material";
import React from "react";
import { sizes } from "../scenarioSetupNewUtils";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./editScenarioNewSlice";
import { useEffect } from "react";
import MultipleSelectChipType from "./MultipleSelectChipType";

const percentText = "(%)";
const commonHeight = sizes.h35;
const SW = sizes.w250;

export default function DefaultSafetyMargin() {
	const dispatch = useDispatch();
	const states = useSelector((store) => store.editScenarioNew);
	const { DSMHigh, DSMMed, DSMLow, DSMOth, editScDetails, SafetyMargin, customerTypes, selectedCustsCGs, filteredCustomerTypes } = states;

	useEffect(() => {
		const CGExist = selectedCustsCGs.filter(x => x.type === "CG" || x.customerGroupID > 0);
		const CGList = { type: "Customer Group", safetyMargin: '', typeCode: "CustomerGroup" };
		let SafetyMarginList = [...SafetyMargin];
		if (CGExist.length > 0) {
			let idx = SafetyMargin.findIndex(x => x.typeCode === "CustomerGroup");
			if (idx === -1) {
				SafetyMarginList.push(CGList);
			}
		} else {
			let idx = SafetyMargin.findIndex(x => x.typeCode === "CustomerGroup");
			if (idx !== -1) {
				SafetyMarginList.splice(idx, 1);
			}
		}
		dispatch(setState("SafetyMargin", SafetyMarginList));
	}, [selectedCustsCGs]);

	useEffect(()=>{
		const distinctCustomerTypeCodes = [
			...new Set(
				filteredCustomerTypes.map(customer => customer.customerTypeCode)
			)
		];
		let SafetyMarginList = SafetyMargin.filter(type => distinctCustomerTypeCodes.includes(type.typeCode) || type.typeCode === "CustomerGroup");
		dispatch(setState("SafetyMargin", SafetyMarginList));
	},[filteredCustomerTypes])

	const handleStateUpdate = (event, stateName) => {
		const value = event.target.value;
		const type = stateName.type;
		const SM = SafetyMargin.map(obj => obj.type === type ? { ...obj, safetyMargin: value } : obj);
		dispatch(setState("SafetyMargin", SM));
	};

	return (
		<Box
			sx={{
				mt: 2,
			}}
		>
			<Grid item sm={12}>
				{/* <Box>
					<Typography sx={{ color: "black.main", fontWeight: "600", mb: 3, fontSize: 14, }}>
						Default Safety Margin{percentText}
					</Typography>
				</Box> */}
				<Box>
					<MultipleSelectChipType />
				</Box>
			</Grid>
			<Box sx={{ mt: 2 }}>
				<Grid  container columnSpacing={1} rowSpacing={2}>
					{SafetyMargin?.map((data, scType) => {
						return (
							<Grid item sm={6} md={4} lg={4} xs={6}>
								<Box>
									<TextField
										type={"number"}
										id="outlined-basic"
										label={data.type}
										variant="outlined"
										size="small"
										sx={{
											height: commonHeight,
											width: "100%",
										}}
										value={data.safetyMargin === "0" ? "" : data.safetyMargin}
										onChange={(event) => {
											const inputValue = parseFloat(event.target.value);
											if (inputValue >= 0 || isNaN(inputValue)) {
												handleStateUpdate(event, data)
											}
										}}
										InputProps={{ autoComplete: "off" }}
									/>
								</Box>
							</Grid>
						);
					})}
				</Grid>
			</Box>
		</Box>
	);
}
